(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-ultimate"] && !Shopify.designMode) return;
  try {
    class ProductCardUltimate {
  constructor() {
    this.wishlist = this.getWishlist();
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateWishlistUI();
  }

  bindEvents() {
    // Wishlist buttons
    document.addEventListener('click', (e) => {
      const wishlistBtn = e.target.closest('.pcu__wishlist-btn');
      if (wishlistBtn) {
        e.preventDefault();
        this.toggleWishlist(wishlistBtn);
      }
    });

    // Add to cart
    document.addEventListener('click', (e) => {
      const addBtn = e.target.closest('.pcu__add-to-cart-btn[data-variant-id]');
      if (addBtn) {
        e.preventDefault();
        this.addToCart(addBtn);
      }
    });

    // Quick view
    document.addEventListener('click', (e) => {
      const qvBtn = e.target.closest('.pcu__quickview-btn');
      if (qvBtn) {
        e.preventDefault();
        const handle = qvBtn.dataset.productHandle;
        if (window.enhancedProductCard) {
          window.enhancedProductCard.openQuickView(handle);
        }
      }
    });

    // Color swatches
    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('.pcu__swatch');
      if (swatch) {
        const card = swatch.closest('.product-card-ultimate');
        const handle = card.dataset.productHandle;
        const color = swatch.dataset.color;
        // Navigate to product with color selected
        window.location.href = `/products/${handle}?variant=${color}`;
      }
    });
  }

  // WISHLIST FUNCTIONS
  getWishlist() {
    const stored = localStorage.getItem('glazpol_wishlist');
    return stored ? JSON.parse(stored) : [];
  }

  saveWishlist() {
    localStorage.setItem('glazpol_wishlist', JSON.stringify(this.wishlist));
  }

  toggleWishlist(btn) {
    const productId = btn.dataset.productId;
    const handle = btn.dataset.productHandle;

    const index = this.wishlist.findIndex(item => item.id === productId);

    if (index > -1) {
      // Remove from wishlist
      this.wishlist.splice(index, 1);
      btn.classList.remove('is-wishlisted');
      this.showToast('Usunięto z ulubionych');
    } else {
      // Add to wishlist
      this.wishlist.push({ id: productId, handle: handle });
      btn.classList.add('is-wishlisted', 'animate-heart');
      setTimeout(() => btn.classList.remove('animate-heart'), 600);
      this.showToast('Dodano do ulubionych ❤️');
    }

    this.saveWishlist();
    this.updateWishlistCount();
  }

  updateWishlistUI() {
    document.querySelectorAll('.pcu__wishlist-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      if (this.wishlist.some(item => item.id === productId)) {
        btn.classList.add('is-wishlisted');
      }
    });
    this.updateWishlistCount();
  }

  updateWishlistCount() {
    const countElements = document.querySelectorAll('[data-wishlist-count]');
    countElements.forEach(el => {
      el.textContent = this.wishlist.length;
      el.style.display = this.wishlist.length > 0 ? 'flex' : 'none';
    });
  }

  // ADD TO CART
  async addToCart(btn) {
    const variantId = btn.dataset.variantId;
    const productTitle = btn.dataset.productTitle;
    const originalContent = btn.innerHTML;

    btn.disabled = true;
    btn.innerHTML = '<div class="spinner" style="width:16px;height:16px;border:2px solid rgba(0,0,0,0.1);border-top-color:#000;border-radius:50%;animation:spin 0.8s linear infinite"></div><span>Dodawanie...</span>';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: 1 }]
        })
      });

      if (!response.ok) throw new Error('Failed to add');

      // Update cart count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.querySelectorAll('[data-cart-count], .cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });

      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg><span>Dodano!</span>';
      btn.style.background = '#10b981';
      btn.style.color = '#fff';

      this.showToast(`${productTitle} dodano do koszyka!`, 'success');

      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalContent;
        btn.style.background = '';
        btn.style.color = '';
      }, 2000);

    } catch (error) {
      console.error('Add to cart error:', error);
      btn.disabled = false;
      btn.innerHTML = originalContent;
      this.showToast('Błąd dodawania do koszyka', 'error');
    }
  }

  // TOAST
  showToast(message, type = 'success') {
    const existing = document.querySelector('.pcu-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = `pcu-toast pcu-toast--${type}`;
    toast.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        ${type === 'success'
          ? '<path d="M20 6L9 17l-5-5"/>'
          : '<path d="M18 6L6 18M6 6l12 12"/>'}
      </svg>
      <span>${message}</span>
    `;
    toast.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      background: ${type === 'success' ? '#10b981' : '#ef4444'};
      color: #fff;
      padding: 14px 20px;
      border-radius: 10px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      font-weight: 500;
      z-index: 9999;
      transform: translateY(100px);
      opacity: 0;
      transition: all 0.3s ease;
    `;

    document.body.appendChild(toast);

    setTimeout(() => {
      toast.style.transform = 'translateY(0)';
      toast.style.opacity = '1';
    }, 10);

    setTimeout(() => {
      toast.style.transform = 'translateY(100px)';
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3000);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.productCardUltimate = new ProductCardUltimate();
  });
} else {
  window.productCardUltimate = new ProductCardUltimate();
}

// Add spinner keyframes
if (!document.getElementById('pcu-styles')) {
  const style = document.createElement('style');
  style.id = 'pcu-styles';
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}
  } catch(e) { console.error(e); }
})();

})();
